"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var files;
        (function (files) {
            var downloading;
            (function (downloading) {
                class InitArgs {
                    constructor() {
                        this.action = appn.emptyString;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    window.location.href = _initArgs.action;
                }
                downloading.init = init;
            })(downloading = files.downloading || (files.downloading = {}));
        })(files = views.files || (views.files = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
